// Open all details in print view or close them on print view leave.
const printDetails = isOpen => document.querySelectorAll('details').forEach(details => (details.open = isOpen));
const printRemoveFadeIn = () => document.querySelectorAll('.fade-in').forEach(elem => elem.classList.remove('fade-in'));

const beforePrint = () => {
    printDetails(true);
    printRemoveFadeIn();
};

window.addEventListener('beforeprint', beforePrint);
window.addEventListener('afterprint', () => printDetails(false));
